/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';

var destroy = require('./plugin/destroy');
var initialize = require('./plugin/initialize');
var update = require('./plugin/update');

module.exports = {
  initialize: initialize,
  update: update,
  destroy: destroy
};




//////////////////
// WEBPACK FOOTER
// ./node_modules/perfect-scrollbar/src/js/main.js
// module id = 1228
// module chunks = 76